import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=0e4722ae&scoped=true&"
import script from "./CustomerFeedback.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFeedback.vue?vue&type=style&index=0&id=0e4722ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4722ae",
  null
  
)

export default component.exports